import { render, staticRenderFns } from "./Packet.vue?vue&type=template&id=baf608fe&scoped=true&"
import script from "./Packet.vue?vue&type=script&lang=js&"
export * from "./Packet.vue?vue&type=script&lang=js&"
import style0 from "./Packet.vue?vue&type=style&index=0&id=baf608fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf608fe",
  null
  
)

export default component.exports